import {
  BADGE_VALUES,
  ElementUIState,
} from '../../Controllers/UIController/UITypes';
import { waitFor } from '../../utils';
import { TutorialModule } from './TutorialModule';
import { t } from 'i18next';

export class EarnButton extends TutorialModule {
  id = 'EarnButton' as 'EarnButton';

  onAction = (id?: string) => {
    this.app.ui.tooltip.hide();
    if (id === 'earn') {
      this.onComplete();
    }
  };

  execute = async () => {
    this.app.ui.setTutorialUIState({
      badges: {
        mine: 0,
        earn: 0,
        friends: 0,
        boosters: 0,
        trading: BADGE_VALUES.TRADING_ALERT,
      },
    });

    this.app.ui.setClickerUIState({
      btnClicker: ElementUIState.Normal,
      btnLeague: ElementUIState.Inactive,

      footer: ElementUIState.Normal,

      btnFriends: ElementUIState.Normal,
      btnMine: ElementUIState.Normal,
      btnEarn: ElementUIState.Highlight,
      btnBooster: ElementUIState.Normal,
      btnTeam: ElementUIState.Hidden,
    });

    this.app.nav.goToHomePage();

    await waitFor(500);

    this.app.tutorial.showTooltip({
      text: t('tut_tooltip_earncoinsinseconds'),
      origin: { x: '100%', y: '100%' },
      offset: { x: '-76px', y: '-185px' },
      align: 'bottom',
    });

    return super.execute().then(() => {
      this.app.ui.popup.close();
      this.app.ui.setClickerUIState({ btnEarn: ElementUIState.Normal });
    });
  };

  getAnalyticsOpts() {
    return {
      key: 'FTUE_earn_intro_dialog',
    };
  }
}
